<template>
    <div>
        <template v-if="canView == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> My Loans </h1>
                </div>
                <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="allowed-tab" data-toggle="tab" href="#allowed" role="tab" aria-controls="allowed" aria-selected="true">Allowed Loans</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="paidloan-tab" data-toggle="tab" href="#paidloan" role="tab" aria-controls="paidloan" aria-selected="false">Paid Loans</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="unpaidloan-tab" data-toggle="tab" href="#unpaidloan" role="tab" aria-controls="unpaidloan" aria-selected="false">Un-Paid Loans</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="approved-tab" data-toggle="tab" href="#approvedloan" role="tab" aria-controls="approvedloan" aria-selected="false">Approved Loans</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="reviewloan-tab" data-toggle="tab" href="#reviewloan" role="tab" aria-controls="reviewloan" aria-selected="false">Review Loans</a>
                    </li>
                </ul>
                <!-- <div class="searching float-right">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div> -->
            </div>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="allowed" role="tabpanel" aria-labelledby="allowed-tab">
                    <table id="dt-allowedloan" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Company Name</th>
                                <th>DBR Percentage</th>
                                <th>Allowed Loan</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> {{salary.name}} </td>
                                <td> {{salary.dbr_percentage}}%</td>
                                <td> {{salary.allowed_loans | loanFilterLocal}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tab-pane fade" id="paidloan" role="tabpanel" aria-labelledby="paidloan-tab">
                    <table id="dt-paidloan" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Loan Name</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(loan, index) in data.paid_loans" :key="index">
                                <td> {{loan.loan_name}} </td>
                                <td> {{loan.transaction_date}} </td>
                                <td> {{formatAmount(loan.amount_disbursed)}} </td>
                                <td> <span class="status on-time">{{loan.status_title}} </span> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tab-pane fade" id="unpaidloan" role="tabpanel" aria-labelledby="unpaidloan-tab">
                    <table id="dt-unpaidloan" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Loan Name</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(loan, index) in data.unpaid_loans" :key="index">
                                <td> {{loan.loan_name}} </td>
                                <td> {{loan.transaction_date}} </td>
                                <td> {{formatAmount(loan.amount_disbursed)}} </td>
                                <td> <span class="status late">{{loan.status_title}} </span> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tab-pane fade" id="approvedloan" role="tabpanel" aria-labelledby="approvedloan-tab">
                    <table id="dt-approvedloan" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Loan Name</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(loan, index) in data.approved_loans" :key="index">
                                <td> {{loan.loan_name}} </td>
                                <td> {{loan.transaction_date}} </td>
                                <td> {{formatAmount(loan.amount_disbursed)}} </td>
                                <td> <span class="status on-time">{{loan.status_title}} </span> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tab-pane fade" id="reviewloan" role="tabpanel" aria-labelledby="reviewloan-tab">
                    <table id="dt-reviewloan" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Loan Name</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(loan, index) in data.review_loans" :key="index">
                                <td> {{loan.loan_name}} </td>
                                <td> {{loan.transaction_date}} </td>
                                <td> {{formatAmount(loan.amount_disbursed)}} </td>
                                <td> <span class="status on-time">{{loan.status_title}} </span> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </template>
        <template v-if="canView == null">
            <preLoader/>
        </template>
        <template v-if="canView == false">
            <div class="empty-main">
                <div class="empty-inner">
                    <img src="/images/new_empty_payments.png" alt="" />
                    <h2> Hi, {{$global.user_name}}! </h2>
                    <p> You have not applied for any loan yet. </p>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
const loanTypes = [
    { key: 'scl', value: 'Supply Chain Loan' },
    { key: 'aas', value: 'Advance Against Salary' },
    { key: 'rzl', value: 'Rozee Professional Loan' },
    { key: 'emi', value: 'QistonPay' },
    { key: 'nl', value: 'Asaan Loan' },
    { key: 'promo', value: 'Digital Lending' },
    { key: '3sl', value: 'Supply Chain Loan - 3 Months' },
    { key: 'wel', value: 'Women Education Loan' },
    { key: 'tal', value: 'Term Advance Loan' }
];
    export default {
        data() {
            return {
                canView: null,
                data: [],
                salary: null,
            };
        },
    	filters: {
            //Loan Types
            loanFilterLocal: function(obj){
                let arr = [];
                _.forEach(obj, function(e, i){
                    loanTypes.find((element) => {
                        if(element.key == e){
                            arr.push(element.value);
                        }else{
                            return '';
                        }
                    });
                });
                var result = arr.map(function(val) {
                    return val;
                }).join(', ');
                return result;
            }

        },

        created() {
        },

        mounted() {
            var that = this;
            this.$Progress.start();
            this.getUserLoanById();
            this.$global.getName();
        },

        methods: {
            getUserLoanById(){
                var that = this;
                axios.get('/api/listMyLoan')
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == 200){
                                this.canView = true;
                                this.data = res.data.users;
                                this.salary = res.data.users.salary;
                                
                            }else if(res.data.code == 219){
                                this.canView = false;
                            }else{
                                this.canView = false;
                            }
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    }).then(res => {
                        $("#dt-allowedloan").dataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>'
                        });
                        $("#dt-paidloan").dataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>'
                        });
                        $("#dt-unpaidloan").dataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>'
                        });
                        $("#dt-approvedloan").dataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>'
                        });
                        $("#dt-reviewloan").dataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>'
                        });
                    }).catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                    });
            },

        }
    }
</script>
